import { Component, EventEmitter, Output } from '@angular/core';
import { ControlBase } from '../../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'plus-button-control',
    standalone: false,
    template: `
        <button class="btn" (click)="click()">
            <img src="@imagesDir/plus.png" />
            <span class="mx-1">{{ 'common.add' | translate }}</span>
        </button>
    `,
    styles: `
        button > img {
            width: 24px;
            height: 24px;
        }

        .btn span {
            writing-mode: horizontal-tb;
            text-orientation: mixed;
            display: inline;
        }
    `,
})
export class PlusButtonControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Output() onClick = new EventEmitter<void>();

    public click = async (): Promise<void> => {
        this.onClick.emit();
    };
}
